import { serviceLocalization } from "./index";

const Country = {
  ...serviceLocalization,
  resource: "countries"
};
export default Country;
